module.exports = __webpack_public_path__ + "img/dark-check.eeb5a847.svg";